import * as v from 'valibot';
import { createEnv } from 'valibot-env/nextjs';

/** Valibot schema for ADVISORS_CSV_UPLOAD_MAX_BYTES. */
export const advisorsCsvUploadMaxBytesSchema = v.pipe(
  v.string(),
  v.transform((val) => (val ? Number(val) : 31457280)),
  v.number(),
  v.minValue(1),
);

export const env = createEnv({
  schema: {
    /*
     * Serverside Environment variables, not available on the client.
     * Will throw if you access these variables on the client.
     */
    private: {
      GTM_ID: v.fallback(v.string(), ''),
      CRON_SECRET: v.fallback(v.string(), ''),
      DATADOG_API_KEY: v.fallback(v.string(), ''),
      EDGE_CONFIG: v.fallback(v.pipe(v.string(), v.url()), ''),
      EDGE_CONFIG_ID: v.fallback(v.string(), ''),
      VERCEL_API_TOKEN: v.fallback(v.string(), ''),
      SECTION_SPECIFIC_ML_CLOUDFRONT_URL: v.fallback(v.string(), ''),
      TARGET_CONFIG: v.fallback(v.picklist(['dev', 'stage', 'prod']), 'dev'),
      LOG_LEVEL: v.fallback(
        v.picklist(['fatal', 'error', 'warn', 'info', 'debug', 'trace', 'silent']),
        'info',
      ),
      S3_ADVISORS_CSV_UPLOAD_BUCKET: v.fallback(v.string(), ''),
      AWS_REGION: v.fallback(v.string(), 'us-east-1'),
      AWS_ACCESS_KEY_ID_ADVISORS_CSV_UPLOAD: v.fallback(v.string(), ''),
      AWS_SECRET_ACCESS_KEY_ADVISORS_CSV_UPLOAD: v.fallback(v.string(), ''),
      ADVISORS_CSV_UPLOAD_MAX_BYTES: v.fallback(advisorsCsvUploadMaxBytesSchema, 31457280),
    },
    /*
     * Environment variables available on the client (and server).
     *
     * 💡 You'll get type errors if these are not prefixed with NEXT_PUBLIC_.
     */
    public: {
      NEXT_PUBLIC_ABSMARTLY_API_KEY: v.fallback(v.string(), ''),
      NEXT_PUBLIC_ABSMARTLY_URL: v.fallback(
        v.pipe(v.string(), v.url()),
        'https://nerdwallet.absmartly.io/v1',
      ),
      NEXT_PUBLIC_DEPLOYABLE_ENV: v.fallback(v.picklist(['dev', 'stage', 'prod']), 'dev'),
      NEXT_PUBLIC_NW_URL: v.fallback(v.pipe(v.string(), v.url()), 'https://stage.nerdwallet.biz'),
      NEXT_PUBLIC_DD_APP_ID: v.fallback(v.string(), ''),
      NEXT_PUBLIC_DD_CLIENT_TOKEN: v.fallback(v.string(), ''),
      NEXT_PUBLIC_SEGMENT_WRITE_KEY: v.fallback(v.string(), ''),
      NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: v.fallback(v.string(), ''),
    },
  },
  /*
   * Due to how Next.js bundles environment variables on Edge and Client,
   * we need to manually destructure them to make sure all are included in bundle.
   *
   * 💡 You'll get type errors if not all variables from `public` & `private` are included here.
   */
  values: {
    CRON_SECRET: process.env.CRON_SECRET,
    DATADOG_API_KEY: process.env.DATADOG_API_KEY,
    EDGE_CONFIG: process.env.EDGE_CONFIG,
    EDGE_CONFIG_ID: process.env.EDGE_CONFIG_ID,
    GTM_ID: process.env.GTM_ID,
    LOG_LEVEL: process.env.LOG_LEVEL,
    VERCEL_API_TOKEN: process.env.VERCEL_API_TOKEN,
    SECTION_SPECIFIC_ML_CLOUDFRONT_URL: process.env.SECTION_SPECIFIC_ML_CLOUDFRONT_URL,
    TARGET_CONFIG: process.env.TARGET_CONFIG,
    NEXT_PUBLIC_ABSMARTLY_API_KEY: process.env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
    NEXT_PUBLIC_ABSMARTLY_URL: process.env.NEXT_PUBLIC_ABSMARTLY_URL,
    NEXT_PUBLIC_DEPLOYABLE_ENV: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
    NEXT_PUBLIC_DD_APP_ID: process.env.NEXT_PUBLIC_DD_APP_ID,
    NEXT_PUBLIC_DD_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    NEXT_PUBLIC_NW_URL: process.env.NEXT_PUBLIC_NW_URL,
    NEXT_PUBLIC_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
    NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    S3_ADVISORS_CSV_UPLOAD_BUCKET: process.env.S3_ADVISORS_CSV_UPLOAD_BUCKET,
    AWS_REGION: process.env.AWS_REGION,
    AWS_ACCESS_KEY_ID_ADVISORS_CSV_UPLOAD: process.env.AWS_ACCESS_KEY_ID_ADVISORS_CSV_UPLOAD,
    AWS_SECRET_ACCESS_KEY_ADVISORS_CSV_UPLOAD: process.env.AWS_SECRET_ACCESS_KEY_ADVISORS_CSV_UPLOAD,
    ADVISORS_CSV_UPLOAD_MAX_BYTES: process.env.ADVISORS_CSV_UPLOAD_MAX_BYTES,
  },
});
